<template>
  <div class="content">
    <div class="container-fluid">
      <div>
  <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/races'}">
          <button type="submit" class="btn btn-warning text-white active btn-sm px-3 mr-3">Yarışlar</button>
        </router-link>
        <router-link :to="{ path: '/seasons'}">
          <button type="submit" class="btn btn-info btn-sm px-3 mr-3">Sezonlar</button>
        </router-link>

        <router-link :to="{ path: '/members'}">
          <button type="submit" class="btn btn-danger btn-sm px-3 mr-3">Üyeler</button>
        </router-link>
      </div>
      <span></span>
    </div>

      <card>
        <div class="col-12 input-group mb-3 d-flex flex-column align-items-start">
          <div class="input-group-prepend mb-3">
            <span class="input-group-text" id="basic-addon1">Revize Sebebi</span>
          </div>
          <tinymce
            id="d1"
            v-model="race.notes"
            v-bind:class="{'is-invalid' : errors.includes('İçerik')}"
            style="width: 100%"
          ></tinymce>
          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-end">
            <button class="btn btn-primary btn-fill mt-2" v-on:click="checkForm">Kaydet</button>
          </div>
        </div>
      </card>
            </div>
    </div>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      id: this.$route.params.id,

      // post data
      race: {
        id: null,
        athletes: null,
        general_music: null,
        document: null,
        club_list: null,
        extra_documents: null,
        status: null,
        notes: null,
        club_name: null,
        email: null,
        phone: null,
        full_name: null
      },
      errors: []
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    checkForm: function() {
      this.errors = [];
      if (!this.race.notes) {
        this.errors.push("İçerik");
      }
      if (!this.errors.length) {
         this.save();
      }
    },
    save: function() {
      if(this.race.status == 5 || this.race.status == 6 || this.race.status == 7){
        this.race.status = 6;
      }else{

        this.race.status=2;
      }
        this.$http.post("/api/race/edit/" + this.race.id, this.race).then(
        response => {
          this.sendMail();
        },
        e => {
 
              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
        }
      );
    },
    sendMail:function(){
        this.$http.post("/api/race/send-rev-mail/" + this.race.id, this.race).then(
        response => {
          this.notifier("top", "right", "success", "Başarılı");
          this.$router.push("/race-applications/"+this.race.post_id);
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
        }
        );
    },
    getInitialData: function() {
      this.toggleLoader();
      this.$http.get("/api/race/get/" + this.id).then(
        response => {
          this.race = response.body;

          this.toggleLoader();
        },
        er => {
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
          return;
        }
      );
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getInitialData();
    });
  }
};
</script>
<style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RaceModules/Edit.vue